import axios from '../axios';

// 核对数据
export const getOrderList = data => {
  return axios({
    url: '/CompanySalaryOrder/findCompanySalaryOrderList',
    method: 'post',
    data
  })
};

// 删除操作
export const del = data => {
  return axios({
    headers: { 'Content-Type': 'multipart/form-data'},
    url: '/CompanySalaryOrder/deleteSalaryOrderInfo',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/http/moudules/send.js